import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable, throwError, BehaviorSubject, of } from "rxjs";
import { retry, catchError, tap, finalize } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BaseService } from "./Services/Base.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private router: Router, private base: BaseService) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // request.headers.append("Company", "IT");

    return next.handle(request).pipe(
      retry(2),
      tap(),

      catchError((error: HttpErrorResponse) => {
        if (error.status === 0 || error.status >= 500) {
          this.base.setInfoError(error.status == 0 ? 500 : error.status);
        }
        this.router.navigateByUrl("Error");
        return throwError(error);
      })
    );
  }
}
